import React, { Component, Suspense } from 'react';
import { ThemeProvider, createTheme } from '@material-ui/core/styles';
import { createBrowserHistory } from 'history';
import { Route, Router, Switch } from 'react-router-dom';

import './App.css';
import Header from './Utils/Header/Header';
import Loader from './Utils/Loader/Loader';
import RedirectComponent from './404Route/ErrorRoute';
import Footer from './Utils/Footer/Footer';

const Home = React.lazy(() => import('./Home/Home'));
const Team = React.lazy(() => import('./Team/Team'));
const Projects = React.lazy(() => import('./Projects/Projects'));
const Contact = React.lazy(() => import('./Contact/Contact'));
const Clients = React.lazy(() => import('./Clients/Clients'));
const AboutUs = React.lazy(() => import('./AboutUs/AboutUs'));

const theme = createTheme({
  palette: {
    primary: {
      main: '#FF6600',
    },
    secondary: {
      main: '#ff8432',
    },
  },
  typography: {
    fontFamily: ['Rajdhani', 'sans-serif'].join(','),
  },
});

export default class App extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.customHistory = createBrowserHistory();
  }
  render() {
    return (
      <ThemeProvider theme={theme}>
        <Router history={this.customHistory}>
          <Suspense
            fallback={
              <>
                <Loader />
              </>
            }>
            <Header />
            <Switch>
              <Route exact path="/" component={Home} />
              <Route path="/core-team" component={Team} />
              <Route path="/projects" component={Projects} />
              <Route path="/contact-us" component={Contact} />
              <Route path="/clients" component={Clients} />
              <Route path="/about-us" component={AboutUs} />
              <Route path="*" component={RedirectComponent} />
            </Switch>
            <Footer />
          </Suspense>
        </Router>
      </ThemeProvider>
    );
  }
}
